import actions  from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export const shopState = {
    shopItems: [],
    shopLoading: false,
    categories: [],
    filter: {
        category:{},
        type: ''
    },
    featuresFilter: [],
    featuresFilterSelected: [],
    typesFilterSelected: null
};

export const shopGetters = {
    ...getters
};

export const shopMutations = {
    ...mutations
};

export const shopActions = {
    ...actions
};
